import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCalendarIllustration = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 52,
	height: 52,
	viewBox: "0 0 52 52",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M6.96875 19.6194C6.96875 17.2908 6.96875 16.1266 7.32703 15.2005C7.86741 13.8037 8.97165 12.6994 10.3684 12.1591C11.2945 11.8008 12.4588 11.8008 14.7873 11.8008H36.3815C38.71 11.8008 39.8743 11.8008 40.8004 12.1591C42.1972 12.6994 43.3014 13.8037 43.8418 15.2005C44.2001 16.1266 44.2001 17.2908 44.2001 19.6194V31.0813H6.96875V19.6194Z",
			fill: "url(#paint0_linear_2049_36182)"
		}),
		/* @__PURE__ */ _jsx("foreignObject", {
			x: 4.28711,
			y: -2.01953,
			width: 23.9785,
			height: 26.6367,
			children: /* @__PURE__ */ _jsx("div", {
				xmlns: "http://www.w3.org/1999/xhtml",
				style: {
					backdropFilter: "blur(4px)",
					clipPath: "url(#bgblur_0_2049_36182_clip_path)",
					height: "100%",
					width: "100%"
				}
			})
		}),
		/* @__PURE__ */ _jsx("path", {
			"data-figma-bg-blur-radius": 8,
			d: "M16.2764 6.48047C18.2032 6.48057 19.7656 8.04283 19.7656 9.96973V12.6289C19.7656 14.5558 18.2032 16.1181 16.2764 16.1182C14.3494 16.1182 12.7871 14.5559 12.7871 12.6289V9.96973L12.792 9.79004C12.8854 7.9465 14.4096 6.48047 16.2764 6.48047Z",
			fill: "#94DCC8",
			fillOpacity: .6,
			stroke: "url(#paint1_linear_2049_36182)"
		}),
		/* @__PURE__ */ _jsx("foreignObject", {
			x: 22.9004,
			y: -2.01953,
			width: 23.9785,
			height: 26.6367,
			children: /* @__PURE__ */ _jsx("div", {
				xmlns: "http://www.w3.org/1999/xhtml",
				style: {
					backdropFilter: "blur(4px)",
					clipPath: "url(#bgblur_1_2049_36182_clip_path)",
					height: "100%",
					width: "100%"
				}
			})
		}),
		/* @__PURE__ */ _jsx("path", {
			"data-figma-bg-blur-radius": 8,
			d: "M34.8896 6.48047C36.8165 6.48057 38.3789 8.04283 38.3789 9.96973V12.6289C38.3789 14.5558 36.8165 16.1181 34.8896 16.1182C32.9627 16.1182 31.4004 14.5559 31.4004 12.6289V9.96973L31.4053 9.79004C31.4987 7.9465 33.0229 6.48047 34.8896 6.48047Z",
			fill: "#94DCC8",
			fillOpacity: .6,
			stroke: "url(#paint2_linear_2049_36182)"
		}),
		/* @__PURE__ */ _jsx("foreignObject", {
			x: -1.03125,
			y: 11.2773,
			width: 53.2305,
			height: 42.5938,
			children: /* @__PURE__ */ _jsx("div", {
				xmlns: "http://www.w3.org/1999/xhtml",
				style: {
					backdropFilter: "blur(4px)",
					clipPath: "url(#bgblur_2_2049_36182_clip_path)",
					height: "100%",
					width: "100%"
				}
			})
		}),
		/* @__PURE__ */ _jsx("path", {
			"data-figma-bg-blur-radius": 8,
			d: "M15.4785 19.7773H35.6904C37.1878 19.7773 38.2808 19.7782 39.1426 19.8486C39.9986 19.9186 40.5827 20.0548 41.0693 20.3027C41.9758 20.7647 42.7129 21.5017 43.1748 22.4082C43.4228 22.8948 43.559 23.479 43.6289 24.335C43.6993 25.1967 43.7002 26.2897 43.7002 27.7871V33.1064C43.7002 35.3486 43.6994 37.0004 43.5928 38.3057C43.4866 39.605 43.2776 40.5171 42.8848 41.2881C42.1679 42.695 41.0241 43.8387 39.6172 44.5557C38.8462 44.9485 37.934 45.1575 36.6348 45.2637C35.3296 45.3703 33.6776 45.3711 31.4355 45.3711H19.7334C17.4913 45.3711 15.8394 45.3703 14.5342 45.2637C13.2349 45.1575 12.3228 44.9485 11.5518 44.5557C10.1448 43.8387 9.00109 42.695 8.28418 41.2881C7.89132 40.5171 7.68235 39.605 7.57617 38.3057C7.46953 37.0004 7.46875 35.3486 7.46875 33.1064V27.7871C7.46875 26.2897 7.46964 25.1967 7.54004 24.335C7.60998 23.479 7.74619 22.8948 7.99414 22.4082C8.4561 21.5017 9.1931 20.7647 10.0996 20.3027C10.5862 20.0548 11.1704 19.9186 12.0264 19.8486C12.4571 19.8134 12.9457 19.795 13.5137 19.7861L15.4785 19.7773Z",
			fill: "#94DCC8",
			fillOpacity: .6,
			stroke: "url(#paint3_linear_2049_36182)"
		}),
		/* @__PURE__ */ _jsx("foreignObject", {
			x: -1.03125,
			y: 11.2773,
			width: 53.2305,
			height: 42.5938,
			children: /* @__PURE__ */ _jsx("div", {
				xmlns: "http://www.w3.org/1999/xhtml",
				style: {
					backdropFilter: "blur(3.68px)",
					clipPath: "url(#bgblur_3_2049_36182_clip_path)",
					height: "100%",
					width: "100%"
				}
			})
		}),
		/* @__PURE__ */ _jsx("path", {
			"data-figma-bg-blur-radius": 7.35296,
			d: "M33.4248 28.5879C33.4246 29.2474 32.89 29.7822 32.2305 29.7822L18.9336 29.7822C18.2742 29.782 17.7395 29.2473 17.7393 28.5879C17.7393 27.9283 18.2741 27.3937 18.9336 27.3936L32.2305 27.3936C32.8901 27.3936 33.4248 27.9282 33.4248 28.5879Z",
			fill: "url(#paint4_linear_2049_36182)",
			fillOpacity: .9,
			stroke: "url(#paint5_linear_2049_36182)",
			strokeWidth: .270524
		}),
		/* @__PURE__ */ _jsx("foreignObject", {
			x: -1.03125,
			y: 11.2773,
			width: 53.2305,
			height: 42.5938,
			children: /* @__PURE__ */ _jsx("div", {
				xmlns: "http://www.w3.org/1999/xhtml",
				style: {
					backdropFilter: "blur(3.68px)",
					clipPath: "url(#bgblur_4_2049_36182_clip_path)",
					height: "100%",
					width: "100%"
				}
			})
		}),
		/* @__PURE__ */ _jsx("path", {
			"data-figma-bg-blur-radius": 7.35296,
			d: "M33.4248 36.5645C33.4246 37.2239 32.89 37.7588 32.2305 37.7588L18.9336 37.7588C18.2742 37.7586 17.7395 37.2238 17.7393 36.5645C17.7393 35.9049 18.2741 35.3703 18.9336 35.3701L32.2305 35.3701C32.8901 35.3701 33.4248 35.9048 33.4248 36.5645Z",
			fill: "url(#paint6_linear_2049_36182)",
			fillOpacity: .9,
			stroke: "url(#paint7_linear_2049_36182)",
			strokeWidth: .270524
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsx("clipPath", {
				id: "bgblur_0_2049_36182_clip_path",
				transform: "translate(-4.28711 2.01953)",
				children: /* @__PURE__ */ _jsx("path", { d: "M16.2764 6.48047C18.2032 6.48057 19.7656 8.04283 19.7656 9.96973V12.6289C19.7656 14.5558 18.2032 16.1181 16.2764 16.1182C14.3494 16.1182 12.7871 14.5559 12.7871 12.6289V9.96973L12.792 9.79004C12.8854 7.9465 14.4096 6.48047 16.2764 6.48047Z" })
			}),
			/* @__PURE__ */ _jsx("clipPath", {
				id: "bgblur_1_2049_36182_clip_path",
				transform: "translate(-22.9004 2.01953)",
				children: /* @__PURE__ */ _jsx("path", { d: "M34.8896 6.48047C36.8165 6.48057 38.3789 8.04283 38.3789 9.96973V12.6289C38.3789 14.5558 36.8165 16.1181 34.8896 16.1182C32.9627 16.1182 31.4004 14.5559 31.4004 12.6289V9.96973L31.4053 9.79004C31.4987 7.9465 33.0229 6.48047 34.8896 6.48047Z" })
			}),
			/* @__PURE__ */ _jsx("clipPath", {
				id: "bgblur_2_2049_36182_clip_path",
				transform: "translate(1.03125 -11.2773)",
				children: /* @__PURE__ */ _jsx("path", { d: "M15.4785 19.7773H35.6904C37.1878 19.7773 38.2808 19.7782 39.1426 19.8486C39.9986 19.9186 40.5827 20.0548 41.0693 20.3027C41.9758 20.7647 42.7129 21.5017 43.1748 22.4082C43.4228 22.8948 43.559 23.479 43.6289 24.335C43.6993 25.1967 43.7002 26.2897 43.7002 27.7871V33.1064C43.7002 35.3486 43.6994 37.0004 43.5928 38.3057C43.4866 39.605 43.2776 40.5171 42.8848 41.2881C42.1679 42.695 41.0241 43.8387 39.6172 44.5557C38.8462 44.9485 37.934 45.1575 36.6348 45.2637C35.3296 45.3703 33.6776 45.3711 31.4355 45.3711H19.7334C17.4913 45.3711 15.8394 45.3703 14.5342 45.2637C13.2349 45.1575 12.3228 44.9485 11.5518 44.5557C10.1448 43.8387 9.00109 42.695 8.28418 41.2881C7.89132 40.5171 7.68235 39.605 7.57617 38.3057C7.46953 37.0004 7.46875 35.3486 7.46875 33.1064V27.7871C7.46875 26.2897 7.46964 25.1967 7.54004 24.335C7.60998 23.479 7.74619 22.8948 7.99414 22.4082C8.4561 21.5017 9.1931 20.7647 10.0996 20.3027C10.5862 20.0548 11.1704 19.9186 12.0264 19.8486C12.4571 19.8134 12.9457 19.795 13.5137 19.7861L15.4785 19.7773Z" })
			}),
			/* @__PURE__ */ _jsx("clipPath", {
				id: "bgblur_3_2049_36182_clip_path",
				transform: "translate(1.03125 -11.2773)",
				children: /* @__PURE__ */ _jsx("path", { d: "M33.4248 28.5879C33.4246 29.2474 32.89 29.7822 32.2305 29.7822L18.9336 29.7822C18.2742 29.782 17.7395 29.2473 17.7393 28.5879C17.7393 27.9283 18.2741 27.3937 18.9336 27.3936L32.2305 27.3936C32.8901 27.3936 33.4248 27.9282 33.4248 28.5879Z" })
			}),
			/* @__PURE__ */ _jsx("clipPath", {
				id: "bgblur_4_2049_36182_clip_path",
				transform: "translate(1.03125 -11.2773)",
				children: /* @__PURE__ */ _jsx("path", { d: "M33.4248 36.5645C33.4246 37.2239 32.89 37.7588 32.2305 37.7588L18.9336 37.7588C18.2742 37.7586 17.7395 37.2238 17.7393 36.5645C17.7393 35.9049 18.2741 35.3703 18.9336 35.3701L32.2305 35.3701C32.8901 35.3701 33.4248 35.9048 33.4248 36.5645Z" })
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint0_linear_2049_36182",
				x1: 44.2001,
				y1: 21.441,
				x2: 6.96875,
				y2: 21.441,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#00897B" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#50AE9C"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint1_linear_2049_36182",
				x1: 11.8882,
				y1: 6.74029,
				x2: 20.2011,
				y2: 16.2624,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "white" }), /* @__PURE__ */ _jsx("stop", {
					offset: .765625,
					stopColor: "white",
					stopOpacity: 0
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint2_linear_2049_36182",
				x1: 30.5015,
				y1: 6.74029,
				x2: 38.8144,
				y2: 16.2624,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "white" }), /* @__PURE__ */ _jsx("stop", {
					offset: .765625,
					stopColor: "white",
					stopOpacity: 0
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint3_linear_2049_36182",
				x1: 5.10718,
				y1: 21.1769,
				x2: 21.2049,
				y2: 55.5968,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "white" }), /* @__PURE__ */ _jsx("stop", {
					offset: .765625,
					stopColor: "white",
					stopOpacity: 0
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint4_linear_2049_36182",
				x1: 17.7712,
				y1: 27.546,
				x2: 34.4082,
				y2: 30.8011,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "white" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "white",
					stopOpacity: .4
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint5_linear_2049_36182",
				x1: 12.2065,
				y1: 21.9703,
				x2: 36.6669,
				y2: 33.4667,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "white" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "white",
					stopOpacity: 0
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint6_linear_2049_36182",
				x1: 17.7712,
				y1: 35.5226,
				x2: 34.4082,
				y2: 38.7777,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "white" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "white",
					stopOpacity: .4
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint7_linear_2049_36182",
				x1: 12.2065,
				y1: 29.9469,
				x2: 36.6669,
				y2: 41.4433,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "white" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "white",
					stopOpacity: 0
				})]
			})
		] })
	]
});
const ForwardRef = forwardRef(SvgCalendarIllustration);
export { ForwardRef as ReactComponent };
